import Vue from "vue";

export default {
  namespaced: true,
  state: {
    applications: [],
  },
  getters: {
    applications: (state) => state.applications,
    applicationsCompleted(state) {
      return state.applications.filter(app => {
        return app.completed
      })
    },
    applicationsNotCompleted(state) {
      return state.applications.filter(app => {
        return app.completed === false
      })
    },
  },
  mutations: {
    SET_APPLICATIONS(state, payload) {
      state.applications = payload
    },
    NEW_APPLICATION(state, payload) {
      state.applications.push(payload)
    },
  },
  actions: {
    async listApplications({commit}) {
      await Vue.axios.get('application/list/')
        .then((response) => {
          commit('SET_APPLICATIONS', response.data);
        })
    },
  }
}
